import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
import LazyLoad from '../lazyload';
import Ellipsis from '../ellipsis';
var cls = 'column-product';
var ColumnProduct = function ColumnProduct(_ref) {
  var className = _ref.className,
    id = _ref.id,
    pid = _ref.pid,
    column = _ref.column,
    product = _ref.product,
    _onClick = _ref.onClick,
    render = _ref.render,
    index = _ref.index;
  var _a, _b;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls,
    locale = _useConfig.locale;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  var off = product.off,
    activityOffs = product.activityOffs;
  var _ref2 = product.product || {},
    colors = _ref2.colors,
    images = _ref2.images,
    inventoryStatus = _ref2.inventoryStatus,
    priceTagCN = _ref2.priceTagCN,
    displayBrand = _ref2.displayBrand,
    brand = _ref2.brand,
    name = _ref2.name,
    nameCN = _ref2.nameCN,
    officialURL = _ref2.officialURL;
  var getImgUrl = function getImgUrl() {
    var _a;
    var _ref3 = (images === null || images === void 0 ? void 0 : images[0]) || {},
      full = _ref3.full,
      thumbnail = _ref3.thumbnail;
    var url = (_a = thumbnail || full) === null || _a === void 0 ? void 0 : _a.url;
    return url ? url + "?x-oss-process=image/resize,l_500" : '';
  };
  return _jsxs("div", Object.assign({
    "data-productid": (_a = product.product) === null || _a === void 0 ? void 0 : _a.id,
    "data-pid": pid,
    "data-id": (_b = product.product) === null || _b === void 0 ? void 0 : _b.id,
    "data-componentid": id,
    "data-index": index,
    className: classes,
    onClick: function onClick() {
      var _a;
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        render: render,
        productId: (_a = product.product) === null || _a === void 0 ? void 0 : _a.id,
        componentId: id,
        pid: pid,
        officialURL: officialURL
      });
    }
  }, {
    children: [_jsxs("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-image-container", prefixCls))
    }, {
      children: [_jsx(LazyLoad, {
        children: _jsx("img", {
          src: getImgUrl(),
          alt: ''
        })
      }), (colors === null || colors === void 0 ? void 0 : colors.length) && colors.length > 1 && column !== 3 ? _jsxs("div", Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-colors", prefixCls))
      }, {
        children: [colors.length, "\u8272\u53EF\u9009"]
      })) : null, inventoryStatus !== 'AVAILABLE' && _jsx("div", Object.assign({
        className: 'sold-out'
      }, {
        children: locale === null || locale === void 0 ? void 0 : locale.product.SOLD_OUT
      }))]
    })), _jsxs("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-info", prefixCls))
    }, {
      children: [_jsx("div", Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-title", prefixCls))
      }, {
        children: (displayBrand ? displayBrand + " | " : brand + " | ") + (nameCN || name)
      })), _jsx("div", Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-price", prefixCls))
      }, {
        children: priceTagCN
      })), (off || !!(activityOffs === null || activityOffs === void 0 ? void 0 : activityOffs.length)) && _jsxs(Ellipsis, Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-promos", prefixCls))
      }, {
        children: [product.off && _jsx(Ellipsis.Item, Object.assign({
          scale: 0.833,
          className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-promos-item", prefixCls), 'off')
        }, {
          children: off
        })), activityOffs && activityOffs.map(function (off, index) {
          return _jsx(Ellipsis.Item, Object.assign({
            className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-promos-item", prefixCls)),
            scale: 0.833
          }, {
            children: off
          }), index);
        })]
      }))]
    }))]
  }));
};
ColumnProduct.displayName = 'ColumnProduct';
ColumnProduct.defaultProps = {
  column: 2,
  product: {
    product: {}
  }
};
export default ColumnProduct;